import {Fragment, useContext} from 'react';

import LoginContext from '../../../../../store/login-context';
import BackStep from '../General/BackStep/BackStep';
import SignupHelp from '../SignupHelp/SignupHelp';
import UpdateAnswers from '../UpdateAnswers/UpdateAnswers';
import classes from './ServicePositions.module.scss';
import idCard from '../../../../../assets/icons/id-card.svg';
import smartCardReader from '../../../../../assets/icons/smart-card-reader.svg';
import code from '../../../../../assets/icons/code-stars.svg';
import ProgressBar from '../ProgressBar/ProgressBar';

declare function Translate(key: string): string;
declare var _curLang: any;
declare var _loginMethodSmsOtpUrl: any;

const ServicePositions = (props) => {
    const ctx = useContext(LoginContext);

    const onBackStepHandler = () => {
        props.prevScreen(); 
    };

    const onUpdateAnswersClick = () => {
        props.firstScreen();
    };

    const handleServicePosClick = () => {
        switch (_curLang) {
            case "he":
                window.location.href = "https://www.gov.il/he/departments/bureaus?OfficeId=81118354-e792-4e08-9057-f7ae5200cbf9";
                break;
            case "en":
                window.location.href = "https://www.gov.il/en/departments/bureaus?OfficeId=81118354-e792-4e08-9057-f7ae5200cbf9";
                break;
            case "ru":
                window.location.href = "https://www.gov.il/ru/departments/bureaus?OfficeId=81118354-e792-4e08-9057-f7ae5200cbf9";
                break;
            case "ar":
                window.location.href = "https://www.gov.il/ar/departments/bureaus?OfficeId=81118354-e792-4e08-9057-f7ae5200cbf9";
                break;
        
            default:
                break;
        }     
    };

    const handleSignUpBioIdClick = () => {
        sessionStorage.setItem('bioId','true');
        window.location = _loginMethodSmsOtpUrl;        
    }

    const onBioIdActiveClick = () => {         
        window.open("https://www.gov.il/he/service/activation_of_smart_indentification_card", "_blank");     
      };
    
      const onBioIdActivePress = (event) => {
        event.preventDefault();  
        if (event.charCode === 13 || event.charCode === 32){  
            onBioIdActiveClick();  
        }  
      };

    return(        
        <Fragment>  
            <ProgressBar pbWidth="100%"/>                                            
            <div className={classes.container}>   
                <div>         
                    <BackStep prevStep = {onBackStepHandler} />
                
                    <div className={`preRegTitleBold ${classes.title}`}>{Translate('N_Login_Bio_ID_With_Code_Title')}</div>            
                    {/* <div className={`preRegText ${classes.desc}`}>                    
                        <span>{Translate('N_Login_biometric_id_info_1')}</span>                                                                
                    </div>                                                */}
                    <div className='biometric-id-form-description mt-3'>
                        <span className='font-weight-500'>
                            {Translate('N_Login_biometric_id_info_1')}                
                        </span>
                        <section className='methods'>                            
                            <div className='method'>
                                <img src={idCard}  alt='id card'/>
                                <span>
                                    {Translate('N_Login_biometric_id_info_2')}
                                    <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                                        <span className="gov-tooltiptitle">{Translate('N_Login_biometric_id_info_2_2')}</span>
                                        <span className="gov-tooltiptext" tabIndex={0}>
                                            <span>{Translate('N_Login_biometric_id_info_id')}</span><br/>
                                            <a id='bioIdActive' tabIndex={0} 
                                                className="gov-tooltip-link"
                                                onClick={onBioIdActiveClick}
                                                onKeyPress={onBioIdActivePress}
                                            >
                                                {Translate('N_Login_biometric_id_info_id_link')}
                                            </a>
                                        </span>                                       
                                    </a>                             
                                </span>
                                                
                            </div>                                      
                            <div className='method' style={{ marginBottom: '14px' }}>
                                <img src={code}  alt='id code'/>
                                <span>
                                    {Translate('N_Login_biometric_id_info_4')} 
                                    <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                                        <span className="gov-tooltiptitle">{Translate('N_Login_biometric_id_info_4_2')}</span>
                                        <span className="gov-tooltiptext" tabIndex={0}>{Translate('N_Login_biometric_id_info_code')}</span>
                                    </a>                                        
                                </span>   
                                            
                            </div>
                            <div className={`method ${classes.card_reader_container}`}>
                                <img src={smartCardReader} className={classes.card_reader_img}  alt=''/>
                                <div>
                                    <span>
                                        {Translate('N_Login_biometric_id_info_7')}                                        
                                        <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                                            <span className="gov-tooltiptitle">{Translate('N_Login_What_Is_SC_Reader')}</span>
                                            <span className="gov-tooltiptext" tabIndex={0}>{Translate('N_Login_What_Is_SC_Reader_Tooltip')}</span>
                                        </a>                           
                                    </span><br/>
                                    <span>
                                        {Translate('N_Login_biometric_id_info_7_2')}
                                    </span>
                                </div>              
                            </div>
                        </section>
                    </div>


                    <div className={classes.buttons_container}>
                        <button className={classes.btn_service_pos} id='btnServicePositions' onClick={handleServicePosClick}>
                            <span>{Translate('N_General_Service_Station_List')}</span>                     
                        </button>  
                        <button className={classes.btn_signup} id='btnSmartCardReader' onClick={handleSignUpBioIdClick}>
                            <span>{Translate('N_Login_SignUp_Sc_Reader')}</span>                     
                        </button>                                           
                    </div> 

                    <UpdateAnswers  onLinkClick={onUpdateAnswersClick}/>     
                </div>
                <div className={classes.skip}>
                    <SignupHelp />
                </div>
            </div>  
        </Fragment>
    )

};
export default ServicePositions;